import React from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';

const NavLink = ({ label, to }) => (
  <RouterNavLink
    to={to}
    className={({ isActive }) =>
      `block w-full text-left page-link text-sm md:text-base font-medium px-4 py-2 transition-colors duration-200 focus:outline-none ${
        isActive 
          ? 'bg-blue-600 text-white' 
          : 'text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-700'
      }`
    }
  >
    {label}
  </RouterNavLink>
);

export default NavLink;